import { Box, BoxProps } from "@mui/material";
import React from "react";

type Props = BoxProps & {
  children?: React.ReactNode | React.ReactNode[];
  noXMargin?: boolean;
  noYMargin?: boolean;
};

export default function PaddedLayout({
  children,
  noXMargin,
  noYMargin,
  ...rest
}: Props) {
  return (
    <Box
      sx={[
        // Phones get 16px of side margin, not 32px: at 360px wide the larger
        // margin squeezed content into ~300px.
        noXMargin ? { marginX: 0 } : { marginX: { xs: 2, sm: 4 } },
        noYMargin ? { marginY: 0 } : { marginY: 2 },
        { paddingY: 1, marginX: { lg: 8 } },
      ]}
      {...rest}
    >
      {children}
    </Box>
  );
}
